import { globalStyleSheet } from "@/assets/css/global";
import defaultCover from '@/assets/images/default_cover_image.png';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    :host {
      display: flex;
      width: 100px;
      aspect-ratio: 1 / 1;
    }
    
    img {
      width: 100%;
    }
`);
export class RPlaylistCover extends HTMLElement {
    /** @type {string | null | undefined} */
    src;
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [globalStyleSheet, styleSheet];
    }
    connectedCallback() {
        this.#abortController = new AbortController();
        this.#initDOM();
    }
    disconnectedCallback() {
        this.#abortController.abort();
    }
    /** @type {AbortController | undefined} */
    #abortController;
    #createImageEl() {
        const imageEl = document.createElement('img');
        imageEl.src = this.getAttribute('src') || this.src || defaultCover;
        imageEl.addEventListener('error', () => {
            imageEl.src = defaultCover;
        }, { once: true, signal: this.#abortController.signal });
        this.shadowRoot.append(imageEl);
    }
    #initDOM() {
        this.#createImageEl();
    }
}
customElements.define('r-playlist-cover', RPlaylistCover);
